import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-instagram",
  templateUrl: "./med-icon-instagram.component.html",
})
export class MedIconInstagramComponent extends SvgMixinComponent {}
